import { Injectable } from '@angular/core';
import { FilterOptionsContext, SourceFilterOptionsLoader } from '@shared/dataview/options/filter-options.registry';
import { SelectListItem } from '@shared/models/select-list-item';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TenantsOptionsLoader extends SourceFilterOptionsLoader {
  readonly source = 'tenants';

  load(_def: unknown, context: FilterOptionsContext): Observable<SelectListItem[]> {
    return of(context.accessibleTenants.map(tenant => ({ name: tenant.name, value: tenant.id })));
  }
}

@Injectable({ providedIn: 'root' })
export class TenantsWithUnassignedOptionsLoader extends SourceFilterOptionsLoader {
  readonly source = 'tenantsWithUnassigned';

  load(_def: unknown, context: FilterOptionsContext): Observable<SelectListItem[]> {
    return of([
      ...context.accessibleTenants.map(tenant => ({ name: tenant.name, value: tenant.id })),
      { name: 'Unassigned', value: 'unassigned' },
    ]);
  }
}
